import type { HistoricalDataItem } from 'features/Procedure/state/procedure-api.type'

export type HistoricalTableRow = HistoricalDataItem & {
  encounter_date: string
}

export const historicalTableColumns = (onProductClick?: (product: HistoricalTableRow) => void) => [
  {
    title: 'Product',
    dataIndex: 'code_text',
    key: 'code_text',
    render: (codeText: string, record: HistoricalTableRow) => (
      <span className='customLink' onClick={() => onProductClick?.(record)}>
        {codeText}
      </span>
    ),
    sorter: {
      compare: (a: HistoricalTableRow, b: HistoricalTableRow) => {
        return a.code_text.localeCompare(b.code_text)
      },
      multiple: 1,
    },
  },
  {
    title: 'Encounter Date',
    dataIndex: 'encounter_date',
    key: 'encounter_date',
    render: (date: string) => {
      if (!date) return ''
      const dateObj = new Date(date)
      return dateObj.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      })
    },
    sorter: {
      compare: (a: HistoricalTableRow, b: HistoricalTableRow) => {
        return new Date(a.encounter_date).getTime() - new Date(b.encounter_date).getTime()
      },
      multiple: 2,
    },
  },
  {
    title: 'Qty',
    dataIndex: 'units',
    key: 'units',
    render: (units: number) => units.toString(),
    sorter: {
      compare: (a: HistoricalTableRow, b: HistoricalTableRow) => {
        return a.units - b.units
      },
      multiple: 3,
    },
  },
  {
    title: 'Price',
    dataIndex: 'fee',
    key: 'fee',
    render: (fee: number) => `$${fee.toFixed(2)}`,
    sorter: {
      compare: (a: HistoricalTableRow, b: HistoricalTableRow) => {
        return a.fee - b.fee
      },
      multiple: 4,
    },
  },
  {
    title: 'Discount',
    dataIndex: 'discount_amount',
    key: 'discount_amount',
    render: (discountAmount: number | undefined, record: HistoricalTableRow) => {
      if (!discountAmount) return '-'
      const label = record.discount_name ? `${record.discount_name}: ` : ''
      return `${label}$${discountAmount.toFixed(2)}`
    },
    sorter: {
      compare: (a: HistoricalTableRow, b: HistoricalTableRow) => {
        return (a.discount_amount ?? 0) - (b.discount_amount ?? 0)
      },
      multiple: 5,
    },
  },
  {
    title: 'Total',
    dataIndex: 'total_price',
    key: 'total_price',
    render: (totalPrice: number) => `$${totalPrice.toFixed(2)}`,
    sorter: {
      compare: (a: HistoricalTableRow, b: HistoricalTableRow) => {
        return a.total_price - b.total_price
      },
      multiple: 6,
    },
  },
]
